import DuoMascot from './DuoMascot'
import DuoSpeechBubble from './DuoSpeechBubble'
import DuoTypedText from './DuoTypedText'

/**
 * Duolingo never puts the question in a page heading: the mascot stands on the
 * left and says it in a speech bubble pointing at him. Every question screen in
 * the v2 funnel opens with this pair.
 *
 * Takes strings rather than children because it types the question out — see
 * DuoTypedText. The three callers all passed the identical pair of paragraphs,
 * so the styling lives here now too.
 */
export default function DuoMascotPrompt({
  subtitle,
  text,
}: {
  subtitle?: string
  text: string
}) {
  return (
    <div className="flex shrink-0 items-start gap-3">
      {/*
        The entrance sits on a wrapper because DuoMascot carries its own
        infinite `animate-float`, and tailwind-merge treats the two
        `animate-*` classes as the same property and keeps only one.
      */}
      <span className="animate-mascot-in shrink-0">
        <DuoMascot className="h-14 w-14" />
      </span>

      <div className="grow pt-1">
        <DuoSpeechBubble tail="left">
          <DuoTypedText
            className="text-duo-ink block text-[17px] leading-snug font-extrabold text-balance"
            text={text}
          />

          {/* Not typed: the aside is support, and typing it would hold up the
              answers behind a line the user does not need to read. */}
          {subtitle && (
            <p className="text-duo-muted mt-1 text-sm leading-relaxed">
              {subtitle}
            </p>
          )}
        </DuoSpeechBubble>
      </div>
    </div>
  )
}
